// ============================================
// INSIGHTS PANEL - Display AI-generated insights
// ============================================

import { AlertTriangle, CheckCircle, Info } from 'lucide-react';
import type { Insight } from '../../types/results';

interface InsightsPanelProps {
    insights: Insight[];
    title?: string;
}

export default function InsightsPanel({ insights, title = 'תובנות' }: InsightsPanelProps) {
    if (insights.length === 0) {
        return (
            <div className="analytics-insights-panel">
                <h3 className="analytics-insights-title">
                    <Info size={18} className="analytics-insights-icon" />
                    {title}
                </h3>
                <div className="analytics-insight analytics-insight-info">
                    <div className="analytics-insight-header">
                        <Info size={14} />
                        אין נתונים
                    </div>
                    <p>עדיין אין מספיק נתונים ליצירת תובנות.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="analytics-insights-panel">
            <h3 className="analytics-insights-title">
                <Info size={18} className="analytics-insights-icon" />
                {title}
            </h3>
            <div className="analytics-insights-list">
                {insights.map((insight, idx) => (
                    <div
                        key={idx}
                        className={`analytics-insight analytics-insight-${insight.type}`}
                    >
                        <div className="analytics-insight-header">
                            {insight.type === 'alert' ? (
                                <AlertTriangle size={14} />
                            ) : insight.type === 'success' ? (
                                <CheckCircle size={14} />
                            ) : (
                                <Info size={14} />
                            )}
                            {insight.title}
                        </div>
                        <p>{insight.message}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
